<template>
  <div class="Home-box">
    <div class="user-card">
      <img class="user-head" :src="touxiang" />
      <div class="user-phone">
        {{ nickname }}
      </div>
    </div>
    <div class="user-func" @click="jump('/information')">
      <div class="func-cell">
        <div class="cell-left">
          <img class="my-ico" src="../assets/Modifythe.png" /><span>资料修改</span>
        </div>
        <i class="my-right" />
      </div>
    </div>
    <div class="user-func" @click="jump('/permissions')">
      <div class="func-cell">
        <div class="cell-left">
          <img class="my-ico" src="../assets/permissions.png" /><span
            >权限管理</span
          ><label :class="{other:stateLabel!=='(已审核)',ed:stateLabel==='(已审核)'}">{{stateLabel}}</label>
        </div>
        <i class="my-right" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Home",
  components: {},
  data() {
    return {
      headsrc: require("../assets/Headportrait.png"),
      touxiang: "",
      nickname: "",
      interID:'',
      stateLabel: ''
    };
  },
  mounted() {
    this.getwxuser();
    this.getPerState()
  },
  destroyed() {
    if(this.interID !== ''){
      clearInterval(this.interID)
      console.log(`已清除[${this.interID}]定时器!`);
    }
  },
  methods: {
    jump(path) {
      this.$router.push({ path });
    },
    getwxuser() {
      const that = this;
      let _user = this.$storage.get("wx_user") || {};
      let _uarr = Object.keys(_user);
      if (_uarr.length > 0 && _uarr.indexOf("headimgurl") > -1) {
        that.touxiang = _user["headimgurl"];
        that.nickname = _user["nickname"];
        return;
      } else {
        that.touxiang = that.headsrc; //"static/my/Headportrait.png";
        that.nickname = "昵称"
      }
    },
    getPerState(){
      const that = this
      that.$store.dispatch("getUpmsUser", {
        ele: that,
        success: function(result) {
          if (result != "" && result.data.length > 0) {
            const _user = that.$storage.get('upmsUser');
            const _role = that.$storage.get('roleDic')
            //用户当前角色名
            const _rolename = _user?_user.role_name:''
            const _perInfo = that.$storage.get('perInfo')
            const _pername = Object.prototype.toString.call(_perInfo) === "[object Object]" && ('name' in _perInfo)?_perInfo.name:''
            if(that.$btools.fuc.getArrayItem('d',_rolename.split(','),_role.map(m=>{return m.role_name})).indexOf('暂无角色') !==-1){
              that.stateLabel = '(未申请)'
            }else{
              if(_rolename.split(',').indexOf(_pername)===-1 && _pername!==''){
                that.stateLabel = '(等待审核)'
                that.getPerStateByInter()
              }else {
                if(_rolename.split(',').indexOf(_pername)!==-1){
                  that.$storage.remove('perInfo')
                }
                that.stateLabel = '(已审核)'
                window.clearInterval(that.$store.state.interObj);
                that.$store.dispatch("removeInter")
              }
            }
          }
        },
        fail: function(err) {
          console.log("authorization->err", err);
          that.$store.dispatch('getTokens',{ ele: that });
        }
      });
    },
    getPerStateByInter(){
      const that = this
      if(that.$store.state.interObj === that.interID){
        return
      }
      if(that.interID === ''){
        let _interID = setInterval(function(){
          console.log('定时器执行!');
          that.getPerState()
        }, 10000);
        that.interID = _interID
        console.log(`已设置[${this.interID}]定时器!`);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@import "~@/styles/index";
.Home-box {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  background-color: rgba(0, 0, 0, 0);
  .user-card {
    width: 95%;
    height: px2rem(186);
    margin: px2rem(38) px2rem(10) px2rem(12) px2rem(10);
    background-image: linear-gradient(156deg, #262a2f 0%, #25292e 100%);
    border-radius: px2rem(12);
    .user-head {
      height: px2rem(66);
      width: px2rem(66);
      margin-top: px2rem(33);
      margin-left: px2rem(25);
      border-radius: 50%;
    }
    .user-phone {
      margin-left: px2rem(25);
      margin-top: px2rem(22);
      font-family: PingFangSC-Semibold;
      font-size: px2rem(16);
      color: #a9abad;
    }
  }
  .user-func {
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: px2rem(53);
    width: 95%;
    margin: 0 px2rem(10) px2rem(12) px2rem(10);
    background-image: linear-gradient(142deg, #2b2f34 0%, #2b2f33 100%);
    box-shadow: inset 0px 3px 6px 0px rgba(0, 0, 0, 0.24),
      inset 0px -2px 2px 0px rgba(255, 255, 255, 0.09);
    border-radius: px2rem(12);
    /*border: 1px solid red;*/
    .func-cell {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      height: 50%;
      width: 100%;
      color: rgb(160, 162, 164);
      .cell-left {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        margin-left: px2rem(32);
        width: 80%;
        .my-ico {
          height: px2rem(20);
          width: px2rem(20);
        }
        span {
          font-size: px2rem(16);
          margin-left: px2rem(13);
        }
        .ed {
          margin-left: px2rem(10);
          font-size: px2rem(16);
          color: #01b876;
        }
        .other {
          margin-left: px2rem(10);
          font-size: px2rem(16);
          color: #e02c00;
        }
      }
      .my-right {
        border: solid rgb(151, 151, 151);
        border-width: 0 1px 1px 0;
        display: inline-block;
        padding: 3px;
        margin-right: px2rem(17);
        transform: rotate(-45deg);
        -webkit-transform: rotate(-45deg);
      }
    }
  }
}
</style>
